import React from 'react';

const RefundPolicy = () => {
  return (
      <div className="min-h-screen bg-linear-to-b from-gray-900 to-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Refund Policy
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              At&nbsp;<strong>olaid</strong>, we believe in transparency and simplicity.
            </p>
          </div>

          {/* Refund policy content */}
          <div className="bg-secondary-dark rounded-lg p-8 text-gray-300 space-y-6 max-w-3xl mx-auto">
            <p>
              That’s why we offer a <strong>one-week free trial</strong> for you to explore and experience the
              benefits of our platform before any payment is processed.
            </p>
            <p>
              Once your subscription begins after the trial, <strong>refunds are not available</strong>.
            </p>
            <p>
              However, you can <strong>cancel your subscription at any time</strong>. You will retain access to
              olaid for the remainder of the paid period, so you can feel confident in your decision to stay with us.
            </p>
          </div>
        </div>
      </div>
  );
};

export default RefundPolicy;
